import Vue from 'vue';
import Router from 'vue-router';
import config from '@/config';
import HomeView from '@/views/HomeView.vue';
import SettingsView from '@/views/SettingsView.vue';
import UserView from '@/views/UserView.vue';
import NotFoundView from '@/views/NotFoundView.vue';
import { BusEvent } from '@/models/bus';
import { bus } from '@/bus';
import VuejsDialog from 'vuejs-dialog';
import JsonView from '@/views/JsonView.vue';
import { PROGRAM_ROUTE } from './routes/program-route';
import { MODULE_ROUTE } from './routes/module-route';
import { SKILL_ROUTE } from './routes/skill-route';
import { TOPIC_ROUTE } from './routes/topic-route';
import { CATEGORY_ROUTE } from './routes/category-route';
import { COURSES_ROUTE } from './routes/course-route';

Vue.use(Router);
Vue.use(VuejsDialog);

const router = new Router({
  base: config.BASE_PATH,
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
      meta: {
        title: 'ELSA Content Creator'
      }
    },
    {
      path: '/settings/',
      name: 'settings',
      component: SettingsView,
      props: () => ({}),
      meta: {
        title: 'Settings · ELSA Content Creator'
      }
    },
    {
      path: '/user/',
      name: 'user',
      component: UserView,
      props: () => ({}),
      meta: {
        title: 'User · ELSA Content Creator'
      }
    },
    ...MODULE_ROUTE,
    ...PROGRAM_ROUTE,
    ...SKILL_ROUTE,
    ...TOPIC_ROUTE,
    ...CATEGORY_ROUTE,
    ...COURSES_ROUTE,
    {
      path: `/json/:id(\\d+)`,
      name: `json-view`,
      component: JsonView,
      props: (route) => ({
        id: parseInt(route.params.id, 10)
      }),
      meta: {
        title: 'View Exercise · ELSA Content Creator'
      }
    },
    {
      path: '**',
      name: 'http404',
      component: NotFoundView,
      props: () => ({}),

      meta: {
        title: 'Page Not Found'
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  bus.$emit(BusEvent.CLEAR_ERROR);
  bus.$emit(BusEvent.PAGE_CHANGE, to.name + '');
  document.title = to.meta.title;
  next();
});

export default router;
